//Check value is entered
//PASS: value is entered, returns true
//FAIL: value is empty, returns false
export const CheckValueRequired = value =>
  value !== null && value !== undefined;
